import { SubmitGroupItemModel, TextInputModel } from '@libs/form/models';

export const EmailItem: TextInputModel = {
  type: 'email',
  name: 'email',
  label: 'E-Mail-Adresse',
  attributes: {
    autocomplete: 'email',
    required: true,
    spellcheck: false,
  },
};

export const SubmitGroupItem: SubmitGroupItemModel = {
  type: 'submit',
  items: [
    {
      name: 'delete',
      label: 'Konto löschen',
      theme: 'filled',
    },
  ],
};
